module.exports = __webpack_public_path__ + "media/dashboard/junanex_logo-3ed5d187.png";